<app-page-header
  class="header"
  [backSwipe]="backSwipeConfig"
  [backButtonRouterLink]="['/main', 'home']"
/>

@if (loading()) {
  <app-loading/>
} @else {
  @let specials = this.specials();

  @if (specials && specials.length > 0) {
    <swiper-container
      class="swiper"
      [autoplay]="false"
      [pagination]="true"
      [direction]="'vertical'"
      [loop]="true"
    >
      <swiper-slide>
        <app-promos-welcome-slide/>
      </swiper-slide>

      @for (slide of specials; track slide.id; let i = $index) {
          @if (slide.contentType === 'image') {
            <swiper-slide>
              <img class="slide" [src]="slide.contentLocal" alt="Promo {{ i + 1 }}"/>
            </swiper-slide>
          } @else if (slide.contentType === 'video') {
            <swiper-slide>
              <video swiperControl class="slide" muted loop [src]="slide.contentLocal"></video>
            </swiper-slide>
          }
      }
    </swiper-container>
  } @else {
    <div class="empty">
      No promos available at this time.
    </div>
  }
}
